import { render, staticRenderFns } from "./SysMessageModal.vue?vue&type=template&id=2b0b6d98&scoped=true&"
import script from "./SysMessageModal.vue?vue&type=script&lang=js&"
export * from "./SysMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0b6d98",
  null
  
)

export default component.exports